// @flow
import { combineReducers } from 'redux';

import coreData, { CoreDataState } from 'ducks/coreDataReducer';
import appConfig, { AppConfigState } from 'ducks/appConfigReducer';
import auth, { AuthState } from 'ducks/authReducer';
import channelContent, {
  type ChannelContentState,
} from 'containers/channels/ducks/channelContentReducer';
import TokenUtils from 'api/auth/TokenUtils';
import { logout } from 'ducks/authActions';

export type AppState = {
  auth: AuthState,
  appConfig: AppConfigState,
  coreData: CoreDataState,
  channelContent: ChannelContentState,
};

export const initialState = {
  auth: AuthState.createWithExistingToken(TokenUtils.getToken()),
};

export const createReducer = (reducers: { [string]: Function } = {}) => {
  const appReducer = combineReducers({
    auth,
    appConfig,
    coreData,
    channelContent,
    ...reducers,
  });

  // the rootReducer resets application state when a user's session ends
  const rootReducer = (state: *, action: *) => {
    if (action.type === logout.toString()) {
      state = initialState;
    }

    return appReducer(state, action);
  };

  return rootReducer;
};



// WEBPACK FOOTER //
// ./src/reducer.js